<template>
    <form class="space-y-4" @submit.prevent="submit">
        <h2 class="text-lg font-semibold">{{ t('login.title') }}</h2>

        <AppTextField
            ref="usernameRef"
            v-model="username"
            :label="t('login.username')"
            autocorrect="off"
            autocapitalize="none"
            required
        />

        <AppTextField v-model="password" type="password" :label="t('login.password')" required />

        <AppButton type="submit" variant="success" :disabled="!valid()" large block>
            {{ t('login.login') }}
        </AppButton>
    </form>

    <AppSnackbar v-model="errorOpen" variant="error">{{ errorMsg }}</AppSnackbar>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue'
    import { useRouter } from 'vue-router'
    import { useAuthStore } from '@/stores/auth'
    import { useI18n } from 'vue-i18n'
    import AppTextField from '@/components/ui/AppTextField.vue'
    import AppButton from '@/components/ui/AppButton.vue'
    import AppSnackbar from '@/components/ui/AppSnackbar.vue'

    const auth = useAuthStore()
    const router = useRouter()
    const { t } = useI18n()

    const username = ref('')
    const password = ref('')
    const usernameRef = ref<InstanceType<typeof AppTextField> | null>(null)
    const errorOpen = ref(false)
    const errorMsg = ref('')

    onMounted(() => usernameRef.value?.focus())

    const valid = () => username.value.length > 0 && password.value.length > 0

    async function submit() {
        if (!valid()) return
        try {
            const result = await auth.loginUser({ username: username.value, password: password.value })
            if (result.ok) {
                void router.push({ name: 'home' })
            } else {
                errorMsg.value = result.message ?? 'Login failed'
                errorOpen.value = true
            }
        } catch (e) {
            errorMsg.value = (e as Error).message
            errorOpen.value = true
        }
    }
</script>
